// $store.financeiro
export const SET_DRAWER_CLIENTES = 'SET_DRAWER_CLIENTES';
export const SET_CLIENTE_SELECIONADO = 'SET_CLIENTE_SELECIONADO';
export const EXCLUIR_PROMISSORIA = 'EXCLUIR_PROMISSORIA';

